import PropTypes from 'prop-types'
import { Pie } from 'react-chartjs-2'

const PieChartCard = ({ title, chartData, chartOptions, emptyMessage }) => {
  const hasData = chartData.datasets[0].data.length > 0
  // Native Chart.js-Legende wird auf das Canvas gezeichnet und kann nicht
  // scrollen. Daher rendern wir eine eigene HTML-Legende, die per Flexbox
  // umbricht (Einträge stehen nebeneinander, solange sie passen) und bei zu
  // vielen Einträgen scrollbar wird.
  const legendOptions = {
    ...chartOptions,
    plugins: {
      ...chartOptions.plugins,
      legend: { ...chartOptions.plugins?.legend, display: false }
    }
  }
  const colors = chartData.datasets[0].backgroundColor || []

  return (
    <div style={{
      backgroundColor: '#1f2937',
      padding: '20px',
      borderRadius: '8px',
      border: '1px solid #374151'
    }}>
      <h3 style={{
        color: '#e5e7eb',
        textAlign: 'center',
        marginBottom: '16px',
        fontSize: '16px',
        fontWeight: '600'
      }}>
        {title}
      </h3>
      <div style={{ height: '210px' }}>
        {hasData ? (
          <Pie data={chartData} options={legendOptions} />
        ) : (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            color: '#9ca3af',
            fontStyle: 'italic'
          }}>
            {emptyMessage}
          </div>
        )}
      </div>
      {hasData && (
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignContent: 'flex-start',
          gap: '6px 14px',
          maxHeight: '90px',
          overflowY: 'auto',
          marginTop: '16px'
        }}>
          {chartData.labels.map((label, i) => (
            <span key={label} style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '12px',
              color: '#e5e7eb',
              whiteSpace: 'nowrap'
            }}>
              <span style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: colors[i % colors.length],
                flexShrink: 0
              }} />
              {label}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

PieChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  chartData: PropTypes.object.isRequired,
  chartOptions: PropTypes.object.isRequired,
  emptyMessage: PropTypes.string.isRequired
}

export default PieChartCard
